// ReceiptDropzone.jsx — referencia de comprobante + input de archivo.

import React from 'react'

const { useState } = React;

const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

function ReceiptDropzone({ reference, onReferenceChange, file, onFileChange }) {
  const [sizeError, setSizeError] = useState(false);

  function handleFileChange(e) {
    const selected = e.target.files?.[0] || null;
    if (selected && selected.size > MAX_FILE_SIZE_BYTES) {
      setSizeError(true);
      onFileChange(null);
      e.target.value = "";
      return;
    }
    setSizeError(false);
    onFileChange(selected);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <input
        type="text"
        value={reference}
        onChange={(e) => onReferenceChange(e.target.value)}
        placeholder="Nº de comprobante (opcional)"
        className="field"
      />
      <label className="dropzone">
        <input
          type="file"
          accept=".jpg,.jpeg,.png,.pdf"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <span className="dropzone-icon">📎</span>
        <span className="dropzone-label">{file ? file.name : "Seleccionar archivo..."}</span>
        <span className="dropzone-hint">JPG / PNG / PDF · Máx. 5 MB</span>
      </label>
      {sizeError && (
        <span className="field-error-text">El archivo supera el máximo de 5 MB. Elige uno más liviano.</span>
      )}
    </div>
  );
}

export { ReceiptDropzone };
